import type { IconSvgObject } from './types';

const TextSelectIcon: IconSvgObject = [
  ["path", { d: "M4.5 2.5C3.39543 2.5 2.5 3.39543 2.5 4.5M19.5 2.5C20.6046 2.5 21.5 3.39543 21.5 4.5M21.5 19.5C21.5 20.6046 20.6046 21.5 19.5 21.5M4.5 21.5C3.39543 21.5 2.5 20.6046 2.5 19.5M14 2.5H15.5M8.5 2.5H10M21.5 8.5V10M21.5 14V15.5M2.5 15.5V14M2.5 8.5V10M8.5 21.5H10M14 21.5H15.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M6.99902 8H14.999M6.99902 12H16.999M6.99902 16H12.999", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default TextSelectIcon;
